import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { DialogContent, DialogTitle, Stack } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { isEmailOrDomain } from "library/jobs/yup-utilities.mjs"

export function RegisterAccessDialog() {
    return (
        <DataInputDialog>
            <DialogTitle data-cy="register-access-dialog-title">Add Register Access</DialogTitle>
            <DialogContent>
                <Stack sx={{ mt: 2 }} spacing={2}>
                    <BoundTextField
                        data-cy="register-access-domain-field"
                        field="authorisedDomain"
                        label="Domain"
                        yup={isEmailOrDomain}
                    />
                </Stack>
            </DialogContent>
        </DataInputDialog>
    )
}
